import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { CustomEase } from "gsap/CustomEase.js";
import { ScrollSmoother } from "gsap/ScrollSmoother";

gsap.registerPlugin(ScrollTrigger, CustomEase, ScrollSmoother);

import horizontalLoop from "../js_modules/_horizontal-loop.mjs";

if (!ScrollTrigger.isTouch) {
  ScrollSmoother.create({
    normalizeScroll: true,
    smoothTouch: false,
  });
  gsap.set("#smooth-content", { willChange: "transform" });
}

import observe from "../js_modules/_observer.mjs";

const scroll_titles = gsap.utils.toArray(".page-about__scrolling-title");
const content_rows = document.querySelectorAll(".page-about__contents-row");
const team_titles = gsap.utils.toArray(".page-about__team-title");
const team_rows = document.querySelectorAll(".page-about__team-row");
const team_table = document.querySelector(".page-about__team-table");
const logos = gsap.utils.toArray(".page-about__logo-cell");

let last_row_target;

let scroll_titles_scrolling = horizontalLoop(scroll_titles, {
  speed: 1,
  repeat: -1,
  paddingRight: 64,
});
let team_titles_scrolling = horizontalLoop(team_titles, {
  speed: 1,
  repeat: -1,
  paddingRight: 64,
});
let contents_images_container = document.querySelector(
  ".page-about__contents-images",
);
let team_floater = document.querySelector(".page-about__team-floater");
let tallest_content_row_height = 0;
let pin_contents_images;

if (logos && logos.length > 0) {
  horizontalLoop(logos, { speed: 0.8, repeat: -1 });
}

function aboutSetupContents() {
  if (window.innerWidth > 980) {
    if (contents_images_container) {
      gsap.set(contents_images_container, { height: "100%" });
    }

    if (content_rows) {
      content_rows.forEach((element, index) => {
        tallest_content_row_height =
          element.offsetHeight > tallest_content_row_height
            ? element.offsetHeight
            : tallest_content_row_height;
        gsap.set(element, { height: "auto" });
      });
      content_rows.forEach((element) => {
        gsap.set(element, { height: tallest_content_row_height });
      });
    }

    if (contents_images_container) {
      gsap.set(contents_images_container, { height: "100%" });
      gsap.set(".page-about__contents-images-track", {
        height: `${100 * content_rows.length}%`,
      });

      if (content_rows) {
        content_rows.forEach((element) => {
          gsap.set(".page-about__contents-single-image", {
            height: `${100 / content_rows.length}%`,
          });
        });
      }

      pin_contents_images = gsap.timeline({
        scrollTrigger: {
          trigger: contents_images_container,
          pin: true,
          scrub: true,
          pinSpacing: false,
          start: "center center+=50",
          end: `+=${document.querySelector(".page-about__contents").offsetHeight - contents_images_container.offsetHeight}`,
        },
      });

      pin_contents_images.to(".page-about__contents-images-track", {
        y: "-66.66%",
        ease: "none",
      });
    }
  } else {
    if (content_rows) {
      content_rows.forEach((element) => {
        gsap.set(element, { height: "auto" });
      });
    }
  }
}

aboutSetupContents();

if (team_rows) {
  gsap.set(".page-about__team-row", { opacity: 0 });
  let table_st = ScrollTrigger.create({
    trigger: ".page-about__team-table",
    start: "top bottom-=20px",
    once: true,
    onEnter: function () {
      gsap.fromTo(
        ".page-about__team-row",
        { y: -40 },
        { y: 0, opacity: 1, stagger: 0.2 },
      );
    },
  });

  team_rows.forEach((row) => {
    if (row.dataset.rowIndex) {
      let image_target = document.querySelector(
        `.page-about__team-floater-image[data-image-index="${row.dataset.rowIndex}"]`,
      );
      row.addEventListener("mouseenter", (e) => {
        gsap.to(team_floater, {
          opacity: 1,
          scale: 1,
          duration: 0.25,
          overwrite: true,
        });

        gsap.set(image_target, { zIndex: 2, overwrite: true });

        gsap.fromTo(
          image_target,
          { opacity: 0 },
          { opacity: 1, duration: 0.25, overwrite: true },
        );
      });
      row.addEventListener("mouseleave", (e) => {
        if (e.relatedTarget && e.relatedTarget.dataset.rowIndex) {
          gsap.set(".page-about__team-floater-image", {
            zIndex: 0,
            overwrite: true,
          });
          gsap.set(image_target, { zIndex: 1, overwrite: true });
        }
        if (!e.relatedTarget || !e.relatedTarget.dataset.row) {
          gsap.to(team_floater, {
            opacity: 0,
            scale: 0.5,
            duration: 0.25,
            overwrite: true,
          });
        }
      });
    }
  });
}

if (team_table) {
  team_table.addEventListener("mousemove", (e) => {
    let rect = team_table.getBoundingClientRect();
    let x = e.clientX - rect.left; //x position within the element.
    let y = e.clientY - rect.top; //y position within the element.
    gsap.set(team_floater, { x: x, y: y, xPercent: -115, yPercent: -75 });
  });
}

if (!ScrollTrigger.isTouch) {
  var aboutResizeTimer;

  window.addEventListener("resize", function (e) {
    clearTimeout(aboutResizeTimer);
    aboutResizeTimer = setTimeout(function () {
      if (pin_contents_images && pin_contents_images.scrollTrigger) {
        pin_contents_images.scrollTrigger.kill(true);
        gsap.set(contents_images_container, { clearProps: true });
        gsap.set(".page-about__contents-images-track", { clearProps: true });
      }

      setTimeout(function () {
        aboutSetupContents();
      }, 100);
    }, 250);
  });
}

observe();
